import { render, staticRenderFns } from "./Child.vue?vue&type=template&id=ed97707c&scoped=true&"
import script from "./Child.vue?vue&type=script&lang=js&"
export * from "./Child.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Child.vue?vue&type=style&index=0&id=ed97707c&prod&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ed97707c",
  null
  ,true
)

export default component.exports